import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from 'libs/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PumpScheduleStageStateManager } from '../../models/pump-schedule-stage-state-manager.model';
import { PumpScheduleStateManager } from '../../state/schedule-state-manager';
import { ViewState } from '../../view-state';

@Component({
    selector: 'job-totals',
    templateUrl: './job-totals.component.html',
    styleUrls: ['./job-totals.component.scss'],
    standalone: false
})
export class JobTotalsComponent {

  public readonly UnitType = UnitType;

  @Input()
  public listPumpScheduleStageStateManager$: Observable<PumpScheduleStageStateManager[]>;

  @Input()
  public readonly scheduleState: PumpScheduleStateManager;

  @Input()
  public jobProcedureTabName: string;

  public get pumpScheduleForm(): UntypedFormGroup {

    return this.scheduleState.form;
  }

  private get _viewState(): ViewState {
    return this.scheduleState.viewState;
  }

  constructor(private ref: ChangeDetectorRef) {

  }

  public get dryWeightVisible(): boolean {

    return this._viewState.isScheduleEditView || this._viewState.isCP2View || this._viewState.isCP1View;
  }

  public get dryVolumeVisible(): boolean {

    return this.dryWeightVisible;
  }

  public get anyMaterialMissingBulkDensity$(): Observable<boolean> {

    return this.scheduleState.anyMaterialMissingBulkDensity$;
  }

  public get cogsVisible$(): Observable<boolean> {

    return this._viewState.cogsVisibleForReviewer$
      .pipe(
        map(visible => {

          return visible && (this._viewState.isScheduleEditView || this._viewState.isCP1View);
        })
      );
  }

  public get cogsAvailable$(): Observable<boolean> {

    return this.scheduleState.cogs$
      .pipe(
        map(scheduleCost => {
          return scheduleCost.totalCOGS !== null
            // ..and no empty children COGS
            && !scheduleCost.stages.some(x => x.fluidMaterials.some(x => x.totalCOGS == null));
        })
      );
  }

  public get cogs$(): Observable<number> {

    if (this.listPumpScheduleStageStateManager$) {
      return this.listPumpScheduleStageStateManager$.pipe(
        map(x => x.map(y => {
          let value = 0;
          y.scheduleState?.cogs$.subscribe(data => {
            value = data.totalCOGS
          })
          return value;
        })),
        map(x => x.sum())
      )
    }
  }

  public get dryWeight$(): Observable<number> {
    if (this.listPumpScheduleStageStateManager$) {
      return this.listPumpScheduleStageStateManager$.pipe(
        map(x => x.map(y => {
          let value = 0;
          y.scheduleState?.dryWeight$.subscribe(data => {
            value = data
          })
          return value;
        })),
        map(x => x.sum())
      )
    }
  }

  public get dryVolume$(): Observable<number> {
    if (this.listPumpScheduleStageStateManager$) {
      return this.listPumpScheduleStageStateManager$.pipe(
        map(x => x.map(y => {
          let value = 0;
          y.scheduleState?.dryVolume$.subscribe(data => {
            value = data
          })
          return value;
        })),
        map(x => x.sum())
      )
    }
  }


  public showCogsHelp(): void {

    this.scheduleState.showCogsHelp();
  }

  public showMissingBulkDensityHelp(): void {

    return this.scheduleState.showMissingBulkDensityHelp();
  }
}
